import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ImageCompressionService {

  MAX_SIZE = 1024 * 1024; // 1 MB
  MAX_WIDTH = 1024;

  constructor() { }

  compressToUnder1MB(file: File): Promise<Blob> {
    let quality = 0.9;

    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = (event: any) => {
        const img = new Image();
        img.src = event.target.result;

        img.onload = () => {
          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');

          const scale = Math.min(1, this.MAX_WIDTH / img.width);
          canvas.width = img.width * scale;
          canvas.height = img.height * scale;

          ctx?.drawImage(img, 0, 0, canvas.width, canvas.height);

          const compressLoop = () => {
            canvas.toBlob((blob) => {
              if (!blob) {
                return reject('Compression failed');
              }

              if (blob.size <= this.MAX_SIZE || quality < 0.1) {
                return resolve(blob);
              } else {
                quality -= 0.05;
                compressLoop();
              }
            }, 'image/jpeg', quality);
          };

          compressLoop();
        };

        img.onerror = (err) => reject('Image load error: ' + err);
      };

      reader.onerror = (err) => reject('File read error: ' + err);
      reader.readAsDataURL(file);
    });
  }
}
